import { HOOK_RESULT__notifier } from '@/hooks/HOOK__notifier';
import cn from 'classnames';
import { PropsWithChildren } from 'react';

interface NotifierWrapperProps extends PropsWithChildren {
  className?: string;
  notifier: HOOK_RESULT__notifier;
}

function NotifierWrapper({ className, notifier, children }: NotifierWrapperProps) {
  return (
    <p
      className={cn(notifier.is_blinking && 'animate-blink-notify', className)}
      style={{ color: notifier.is_blinking ? `var(--user-color-${notifier.color_index})` : '' }}
    >
      {children}
    </p>
  );
}

export default NotifierWrapper;
